import {
  Module,
  VuexModule,
  getModule,
  Mutation,
} from "vuex-module-decorators";

import { ProgramChain } from "../../data/models/ProgramChain";

const name = "programChain";

import store from "@/store";

if (store.state[name]) {
  store.unregisterModule(name);
}

export interface ProgramChainOfAssignment {
  assignmentId: string;
  programChain: ProgramChain;
}

@Module({ dynamic: true, namespaced: true, store, name: name })
export class ProgramChainVuexModule extends VuexModule {
  programChainCache = new Map<string, ProgramChain>();
  mostRecentProgramChainCache = new Map<string, ProgramChain>();
  programChainOfAssignmentCache = new Map<string, ProgramChain>();

  @Mutation
  cacheProgramChain(programChain: ProgramChain) {
    this.programChainCache.set(programChain.id, programChain);
  }

  @Mutation
  cacheProgramChainOfAssignment(
    programChainOfAssignment: ProgramChainOfAssignment
  ) {
    this.programChainOfAssignmentCache.set(
      programChainOfAssignment.assignmentId,
      programChainOfAssignment.programChain
    );
  }

  @Mutation
  cacheMostRecentProgramChain(programChain: ProgramChain) {
    this.mostRecentProgramChainCache.set(
      programChain.serialNumber,
      programChain
    );
  }

  @Mutation
  clearMostRecentProgramChain(serialNumber: string) {
    this.mostRecentProgramChainCache.delete(serialNumber);
  }

  @Mutation
  clear() {
    this.programChainCache.clear();
    this.mostRecentProgramChainCache.clear();
    this.programChainOfAssignmentCache.clear();
  }

  get cachedProgramChain() {
    const cache = this.programChainCache;

    return function(serialNumber: string) {
      return cache.get(serialNumber);
    };
  }
}

export const ProgramChainModule = getModule(ProgramChainVuexModule);
